// import { DirectUploadController } from "./activestorage/direct_upload_controller";
// import { DirectUpload } from "@rails/activestorage"

import {CoreType} from '../../../@polygonjs/polygonjs/src/core/Type';

interface BlobToFileOptions {
	addExtFromBlobType: boolean;
}
export class CoreFileUtils {
	//
	//
	// CONVERSIONS
	//
	//
	// datauri_to_blob(datauri: string): Blob{
	// 	// convert base64 to raw binary data held in a string
	// 	// doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
	// 	const datauri_elements = datauri.split(',');
	// 	const encoded_type = datauri_elements[0].split(';')[1];

	// 	const is_base64 = (encoded_type != null) && (encoded_type === 'base64');
	// 	const byteString = is_base64 ?
	// 		atob(datauri_elements[1])
	// 	:
	// 		datauri_elements[1];

	// 	// separate out the mime component
	// 	const mimeString = datauri.split(',')[0].split(':')[1].split(';')[0];

	// 	// write the bytes of the string to an ArrayBuffer
	// 	const ab = new ArrayBuffer(byteString.length);

	// 	// create a view into the buffer
	// 	const ia = new Uint8Array(ab);

	// 	// set the bytes of the buffer to the correct values
	// 	//for (i = 0; i < byteString.length; i++)
	// 	for (let i = 0, end = byteString.length, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
	// 		ia[i] = byteString.charCodeAt(i);
	// 	}

	// 	// write the ArrayBuffer to a blob, and you're done
	// 	const blob = new Blob([ab], {type: mimeString});
	// 	return blob;
	// }

	// text_to_blob: (text) ->
	// 	byteString = atob(text)

	// 	ab = new ArrayBuffer(byteString.length)

	// 	# create a view into the buffer
	// 	ia = new Uint8Array(ab)

	// 	# set the bytes of the buffer to the correct values
	// 	#for (i = 0; i < byteString.length; i++)
	// 	for i in [0...byteString.length]
	// 		ia[i] = byteString.charCodeAt(i)

	// 	# write the ArrayBuffer to a blob, and you're done
	// 	blob = new Blob([ab], {type: mimeString})
	// 	blob

	static async imageUrlToBlob(url: string): Promise<Blob | null> {
		return new Promise((resolve) => {
			const image = new Image();
			image.crossOrigin = 'Anonymous';
			image.onload = () => {
				// const response = await fetch(url, {mode: 'no-cors'});
				// const blob = await response.blob();

				// document.body.innerHTML = `<img src="${CoreFileUtils.blobToDatauri(blob)}"></img>`;
				// document.body.innerHTML = '';
				// document.body.append(image);

				const canvasElement = document.createElement('canvas');
				// videoWidth and videoHeight are more robust than .width and .height (see https://discourse.threejs.org/t/how-to-get-camera-video-texture-size-or-resolution/2879)
				canvasElement.width = image.width;
				canvasElement.height = image.height;
				const canvasCtx = canvasElement.getContext('2d')!;
				canvasCtx.drawImage(image, 0, 0, canvasElement.width, canvasElement.height);
				canvasElement.toBlob((blob) => {
					resolve(blob);
				});

				//this.setThumbnailStaticBlob(blob);
			};
			image.src = url;
		});
	}

	static async blobToDatauri(blob: Blob): Promise<string> {
		return new Promise((resolve) => {
			const reader = new FileReader();
			reader.onload = (e: ProgressEvent<FileReader>) => {
				const result = e.target?.result;
				if (CoreType.isString(result)) {
					resolve(result);
				}
			};
			reader.readAsDataURL(blob);
		});
	}

	static downloadBlob(blob: Blob, filename: string) {
		const urlCreator = window.URL || window.webkitURL;
		const blobUrl = urlCreator.createObjectURL(blob);

		const element = document.createElement('a');
		element.setAttribute('href', blobUrl);
		element.setAttribute('target', '_blank');
		element.setAttribute('download', filename);

		element.style.display = 'none';
		document.body.appendChild(element);
		element.click();

		document.body.removeChild(element);
	}

	static blobToFile(blob: Blob, filename: string, options: BlobToFileOptions = {addExtFromBlobType: true}): File {
		// A Blob() is almost a File() - it's just missing the two properties below which we will add
		// blob.lastModifiedDate = new Date()
		// blob.name = filename
		// blob
		if (options.addExtFromBlobType) {
			const ext = blob.type.split('/')[1];
			filename = `${filename}.${ext}`;
		}
		return new File([blob], filename, {type: blob.type});
	}

	static fileToDataURL(file: File): Promise<string> {
		return new Promise((resolve) => {
			// encode the file using the FileReader API
			const reader = new FileReader();
			reader.onloadend = () => {
				// use a regex to remove data url part
				const base64String = (reader.result as any).replace('data:', '').replace(/^.+,/, '');

				// log to console
				// logs wL2dvYWwgbW9yZ...
				resolve(base64String);
			};
			reader.readAsDataURL(file);
		});
	}
}
